/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Check: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="check" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M600.6666666666666 442.0000000000001L1000.1666666666666 841.5000000000001L920.8333333333331 920.8333333333334L600.6666666666666 600.6666666666667L439.1666666666667 762.1666666666667L359.8333333333333 682.8333333333334L600.6666666666666 442.0000000000001z" : "M480.5333333333334 353.6L800.1333333333333 673.2L736.6666666666667 736.6666666666667L480.5333333333334 480.5333333333334L351.3333333333334 609.7333333333333L287.8666666666667 546.2666666666667L480.5333333333334 353.6z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Check.displayName = `Blueprint5.Icon.Check`;
export default Check;
